<template>
    <div class="navigator-callout" :class="'navigator-callout--' + type">
        <div class="navigator-callout__icon">
            <svg v-if="type === 'info'" width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            <svg v-else-if="type === 'success'" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M22 4L12 14.01l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <svg v-else-if="type === 'warning'" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" stroke-width="2"/><path d="M12 9v4M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </div>
        <div class="navigator-callout__text">{{ content }}</div>
    </div>
</template>

<script>
export default {
    name: 'NavigatorCallout',
    props: {
        type: { type: String, default: 'info' },
        content: { type: String, default: '' },
    },
};
</script>

<style scoped>
.navigator-callout {
    display: flex;
    gap: 10px;
    padding: 12px 16px;
    border-radius: var(--compass-radius-sm, 8px);
    font-size: 13px;
    line-height: 1.5;
    border: 1px solid;
}

.navigator-callout--info {
    background: rgba(139, 92, 246, 0.06);
    border-color: rgba(139, 92, 246, 0.15);
    color: var(--nav-text-secondary, #6b7280);
}
.navigator-callout--info .navigator-callout__icon { color: #8b5cf6; }

.navigator-callout--success {
    background: rgba(34, 197, 94, 0.06);
    border-color: rgba(34, 197, 94, 0.15);
    color: var(--nav-text-secondary, #6b7280);
}
.navigator-callout--success .navigator-callout__icon { color: #22c55e; }

.navigator-callout--warning {
    background: rgba(245, 158, 11, 0.06);
    border-color: rgba(245, 158, 11, 0.15);
    color: var(--nav-text-secondary, #6b7280);
}
.navigator-callout--warning .navigator-callout__icon { color: #f59e0b; }

.navigator-callout--danger {
    background: rgba(239, 68, 68, 0.06);
    border-color: rgba(239, 68, 68, 0.15);
    color: var(--nav-text-secondary, #6b7280);
}
.navigator-callout--danger .navigator-callout__icon { color: #ef4444; }

.navigator-callout__icon { flex-shrink: 0; margin-top: 1px; }
.navigator-callout__text { flex: 1; }
</style>
